import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Update Fulfilled ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Update Pickup ")
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showModalUpdateTracking,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModalUpdateTracking) = $event)),
    title: "Update Delivery",
    top: "10vh",
    width: "80%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                type: _ctx.getOrderStatusColor(_ctx.orderStatusValue),
                size: "small",
                title: "Order status"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.orderStatusValue), 1)
                ]),
                _: 1
              }, 8, ["type"]),
              _createVNode(_component_el_table, {
                data: _ctx.data,
                style: {"width":"100%"},
                stripe: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "trackingNumbers",
                    label: "Tracking number",
                    "min-width": 15
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row?.trackingNumbers.join(', ')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "carriers",
                    label: "Carrier",
                    "min-width": 10
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row?.carriers.join(', ')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Items",
                    label: "items",
                    "min-width": 50
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_table, {
                        data: scope.row.items,
                        style: {"width":"100%"},
                        stripe: "",
                        "show-header": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "imageSrc",
                            label: "Preview",
                            "min-width": 10
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_image, {
                                style: {"width":"80px","height":"80px"},
                                fit: "cover",
                                src: _ctx.imageUrl(scope.row.imageSrc, true, 200),
                                "preview-src-list": [_ctx.imageUrl(scope.row.imageSrc)],
                                width: "100px"
                              }, {
                                error: _withCtx(() => [
                                  _createVNode(_component_slot_error)
                                ]),
                                _: 2
                              }, 1032, ["src", "preview-src-list"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_table_column, {
                            prop: "itemName",
                            label: "Description",
                            "min-width": 10
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "variantTitle",
                            label: "Variant title",
                            "min-width": 10
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "catalogCode",
                            label: "Catalog code",
                            "min-width": 10
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "quantity",
                            label: "Quantity",
                            "min-width": 10
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "status",
                            label: "Status",
                            "min-width": 10
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_tag, {
                                type: _ctx.getOrderStatusColor(scope.row.status),
                                size: "small",
                                title: "Order status"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.status), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Action",
                    "min-width": 10
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                onClick: ($event: any) => (_ctx.onUpdateFulfilledOrderItems(scope.row)),
                                disabled: 
                    !scope.row.items.some(
                      item => item?.status === _ctx.ORDER_STATUS.IN_TRANSIT
                    )
                  
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 24,
                            hidden: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                onClick: ($event: any) => (_ctx.onUpdateFulfilledOrderItems(scope.row)),
                                disabled: 
                    !scope.row.items.some(
                      item => item?.status === _ctx.ORDER_STATUS.IN_TRANSIT
                    )
                  
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}